<template>
  <VCard
    flat
    class="interview-processing grey lighten-4 fill-height"
  >
    <div class="interview-processing__wrap">
      <img class="interview-processing__icon" src="../../assets/img/interview/clock.svg">
      <span class="subitle-1 text-center mt-3 mt-sm-6 font-weight-medium">
      {{ $t('videoProcessing') }}
    </span>
      <span class="body-2 text-center mt-2 grey--text text--darken-1">
      {{ $t('processingTip') }}
      <br>
      {{ $t('processingTip2') }}
    </span>
    </div>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewProcessing',
};
</script>

<style lang="scss" scoped>
  .interview-processing {
    &__wrap {
      padding: 5.375rem 1.25rem;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .interview-processing__icon {
      width: 2.5rem;
    }
  }
</style>

<i18n locale="en" lang="yaml">
  videoProcessing: Video is processing
  processingTip: It can take several minutes.
  processingTip2: Please be patient, it’s worth it.
</i18n>

<i18n locale="ru" lang="yaml">
  videoProcessing: Видео в процессе обработки
  processingTip: Это может занять несколько минут.
  processingTip2: Наберитесь терпения, это того стоит.
</i18n>
